/**
 * ProHabbo
 *
 * Henrique Arthur <eu@henriquearthur.com.br>
 */

 Quotation = {
    loadCategory: function() {
        var button = $(this);

        if (button.hasClass('disabled')) {
            return false;
        }

        var id = $(this).data('id');

        if (id > 0) {
            button.addClass('disabled');
            $("#quotation-furni-list").animate({'opacity': 0.5}, 'fast');

            $.ajax({
                url: '/a/quotation/loadCategory',
                type: 'POST',
                dataType: 'json',
                data: {'id': id},
            }).done(function(data) {
                button.removeClass('disabled');

                $("#quotation-furni-list").animate({'opacity': 1}, 'fast').html(data.html);

                $('html, body').animate({
                    scrollTop: $("#quotation-list-col").offset().top
                }, 1000);
            });
        }
    },
    init: function() {
        $(".quotation-categories .box-category").on('click', Quotation.loadCategory);
    }
};
